import { isNumber } from 'lodash'
import { flatten } from '../../../../utils/array.helper'

export const getQuestionById = (questions, id) => {
    if (!questions || !isNumber(id)) return null

    for (const question of questions) {
        if (question.id === id) return question
        const child = question.children?.find(child => child.id === id)
        if (child) return child
    }

    return null
}

export const getCategoryById = (questions, id) => {
    if (!Array.isArray(questions)) return null

    for (const question of questions) {
        const category = question.categories?.find(category => category.id === id)
        if (category) return category

        const childCategory = question.children
            ?.flatMap(child => child.categories || [])
            .find(category => category.id === id)
        if (childCategory) return childCategory
    }

    return null
}

const getQuestionPropertyById = (questions, id, property) => {
    const question = getQuestionById(questions, id)
    return question ? question[property] : null
}

export const fetchQuestionsSelectors = {
    byId: (arg, result) => ({
        ...result,
        data: getQuestionById(result?.data, arg.id),
    }),
    category: (arg, result) => ({
        ...result,
        data: getCategoryById(result?.data, arg.categoryId),
    }),
    earlierQuestions: (arg, result) => ({
        ...result,
        data: flatten(result?.data, { excludeParents: true })?.slice(
            0,
            result?.data?.findIndex(question => question.id === arg.id),
        ),
    }),
    propertyById: (arg, result) => ({
        ...result,
        data: getQuestionPropertyById(result?.data, arg.id, arg.property),
    }),
}
